<template>
  <div class="settings-container">
    <div v-if="activeTab === 'mealSettings'">
      <form @submit.prevent="saveMealSettings">
        <div class="form-group">
          <label for="mealLimit">赊账额度</label>
          <input type="number" id="mealLimit" v-model="mealSettings.mealLimit" required />
        </div>
        <div class="form-group">
          <label for="mealDescription">报餐说明</label>
          <textarea id="mealDescription" v-model="mealSettings.mealDescription" required></textarea>
        </div>
        <button type="submit" class="save-button">保存</button>
      </form>
    </div>
  </div>
</template>

<script>


export default {
  data() {
    return {
      activeTab: 'mealSettings', // 默认显示报餐基础设置
      mealSettings: {
        mealLimit: 800,
        mealDescription: ''
      }
    };
  },
  methods: {
    saveMealSettings() {
      const { mealLimit, mealDescription } = this.mealSettings;

      // 调用 API 保存报餐设置
      this.$axios.post('/api/baocun_baocan_setting', {
        money: mealLimit,
        text: mealDescription
      })
      .then(response => {
        if (response.data.code === 0) {
          this.$message.success('报餐设置保存成功');
        } else {
          this.$message.error(response.data.message);
        }
      })
      .catch(error => {
        this.$message.error('保存报餐设置失败');
        console.error(error);
      });
    },
    fetchMealSettings() {
      this.$axios.get('/api/show_baocan_setting') // 替换为实际的 API 地址
        .then(response => {
          if (response.data.code === 0) {
            const data = response.data.data;
            this.mealSettings.mealLimit = data.money;
            this.mealSettings.mealDescription = data.explain;
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(error => {
          this.$message.error('获取报餐设置失败');
          console.error(error);
        });
    }
  },
  mounted() {
    this.fetchMealSettings(); // 在组件加载时调用 API 获取数据
  }
};
</script>

<style scoped>
.settings-container {
  width: 600px;
  margin: 0 auto;
}

.nav {
  display: flex;
  margin-bottom: 20px;
}

.nav button {
  flex: 1;
  padding: 10px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
  cursor: pointer;
}

.nav .active {
  background-color: #e60000;
  color: white;
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.form-group label {
  width: 150px;
  margin-right: 20px;
  white-space: nowrap;
}

.form-group input,
.form-group select {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.form-group textarea {
  flex: 1;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 200px; /* 增加文本框高度 */
  resize: vertical; /* 允许垂直方向调整大小 */
}

.save-button {
  padding: 10px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 100%;
}

.save-button:hover {
  background-color: #0056b3;
}
</style>